import { Path } from '../../MediaPlan.types';
import { MenuItem } from './Navbar.types';

export const ITEMS: (Omit<MenuItem, 'title'> & { i18nKey: string })[] = [
  {
    i18nKey: 'allPlans',
    key: Path.MEDIA_PLAN,
    path: Path.MEDIA_PLAN
  },
  {
    i18nKey: 'templates',
    key: Path.TEMPLATES,
    path: Path.TEMPLATES
  }
];
